import React from 'react';
import ReactDOM from 'react-dom';
import {PropTypes} from 'prop-types';
import {PropTypesEx} from '../shared/proptypes.extensions';
import {SetFocusOnFirstFormControl, NormalizeClassNameString, PreventDOMLock} from './utils';

/*
    Bootstrap Modal does not support multiple modals (only one visible at time).
*/

const zIndexModal = 1050;

$(document).on(
    'show.bs.modal', 
    '.modal', 
    event => {
        const visibleModalsCount = $('.modal:visible').length;
        const zIndex = zIndexModal + visibleModalsCount; // (100 * visibleModalsCount);
        $(event.target).css('z-index', zIndex);
        setImmediate(() => {
            $('.modal-backdrop')
                .not('.modal-stack')
                .first()
                .css('z-index', zIndex - 1 /*10*/)
                .addClass('modal-stack');
        })
    });


let modalCounter = 0;

const fixModal = () => {
    if ($('.modal:visible').length) {
        $.fn.modal.Constructor.prototype._checkScrollbar();
        $.fn.modal.Constructor.prototype._setScrollbar();
        $('body').addClass('modal-open');
    }
}

class ModalBase extends React.Component {
	constructor(props, ...others) {
        super(props, ...others);

        this._modalId = 'modal-id-' + (modalCounter++);
        this._selector = `[data-modal-id='${this._modalId}']`;

        this.handleModalEvents = this.handleModalEvents.bind(this);
        this.bindModalEvents = this.bindModalEvents.bind(this);
        this.unbindModalEvents = this.unbindModalEvents.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.hide = this.hide.bind(this);
        this.isModalShown = false;
    }

    handleModalEvents(event) {
        const self = this;
        if ((event.namespace == 'bs.modal') && self._isMounted) {
            const isModalShown = self.isModalShown;
            const $modal = self.$modal;
            switch (event.type) {
                case 'shown':
                    event.stopPropagation();
                    self.isModalShown = true;
                    if (self.props.autoFocus && self._isMounted && Boolean($modal)) {
                        SetFocusOnFirstFormControl([$modal.find('.modal-body'), $modal.find('.modal-footer'), $modal.find('modal-header')]);
                    }
                    if ((typeof self.props.onShow === 'function') && !isModalShown/*self.props.visible*/) {
                        self.props.onShow(event);
                    }
                    break;
                case 'hidden':
                    event.stopPropagation();
                    fixModal();
                    self.isModalShown = false;
                    if ((typeof self.props.onHide === 'function') && isModalShown/*!self.props.visible*/) {
                        self.props.onHide(event);
                    }
                    break;
            }
        }
    }

    bindModalEvents() {
        const self = this;

        $('body')
            .on('shown.bs.modal show.bs.modal hide.bs.modal hidden.bs.modal', self._selector, self.handleModalEvents);
    }

    unbindModalEvents() {
        const self = this;

        $('body')
            .off('shown.bs.modal show.bs.modal hide.bs.modal hidden.bs.modal', self._selector, self.handleModalEvents);
    }

    handleCloseClick(event) {
        event.preventDefault();
        const self = this;

        PreventDOMLock(self.hide);
    }

    handleKeyPress(event) {
        const self = this;
        if ((event.which == 27) && self.props.allowClose && self.isModalShown && self._isMounted) {
            event.stopPropagation();
            event.preventDefault();
            self.hide();
        }
    }

    hide(fastHide) {
        const self = this;
        const $modal = self.$modal;
        if (Boolean($modal)) {
            if (self.props.visible && !self.isModalShown) { //Animation was started, but still not completed
                //Removing class Fade to prevent animation, then call internal hide. This is hack!
                $modal.removeClass('fade').modal('_hideModal');
            }
            else if (self.isModalShown) {
                //Removing class Fade to prevent animation, then hide
                if (Boolean(fastHide)) {
                    $modal.removeClass('fade').modal('hide');
                }
                else {
                    $modal.modal('hide');
                }
            }
        }
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;
        self.$modal = $(self._selector);
        self.bindModalEvents();
        if (self.props.visible) {
            self.$modal.modal('show');
        }
    }

    componentWillUnmount() {
        const self = this;
        self._isMounted = false;
        const $modal = self.$modal;
        if (Boolean($modal)) {
            self.unbindModalEvents();
            const _dispose = () => {
                try {
                    const privateModal = $modal.data('bs.modal');
                    if (Boolean(privateModal) && Boolean(privateModal._element)){
                        $modal.modal('dispose');  
                    }
                } catch(e){}
            }

            //self.hide(true);

            if (self.isModalShown) {
                self.isModalShown = false;
                $modal.removeClass('fade').modal('hide');
                if (typeof self.props.onHide === 'function') {
                    self.props.onHide();
                }
            }

            self.$modal = null;
            setTimeout(_dispose, 1000);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const self = this;
        if (self.$modal) {
            const props = self.props;
            if (prevProps.visible != props.visible) {
                if (props.visible) {
                    self.$modal.modal('show');
                }
                else {
                    self.hide();
                }
            }
        }
    }

    render() {
        const self = this;
        const {title, body, footer, animated, backdrop, allowClose, scrollable, size, className} = self.props;
        const sizeClass = Boolean(size) ? ` modal-${size}` : '';

        const modalClassName= 
            'modal-dialog modal-dialog-centered ' + 
            (Boolean(className) ? className : '') + 
            sizeClass + 
            (scrollable ? ' modal-dialog-scrollable' : '');

        const isSimpleBackdrop = backdrop == 'simple'

        return (
            <div 
                id={self.props.id || undefined} 
                data-modal-id={self._modalId}
                className={'modal' + (animated ? ' fade' : '') + (isSimpleBackdrop ? ' backdrop-simple' : '')}
                data-keyboard={false} 
                onKeyUp={self.handleKeyPress}
                data-focus={false} 
                data-backdrop={isSimpleBackdrop ? false : backdrop} 
                tabIndex={-1} 
                role="dialog"
            >
                <div className={NormalizeClassNameString(modalClassName)} role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">{title}</div>
                            <button 
                                type="button" 
                                className={'close' + (allowClose ? '' : ' invisible')} 
                                aria-label="Close" 
                                onClick={self.handleCloseClick}
                                disabled={!allowClose}
                            >
                                <span aria-hidden="true" className="sbkico-close" />
                            </button>
                        </div>
                        <div className="modal-body">{body}</div>
                        <div className="modal-footer">{footer}</div>
                    </div>
                </div>
            </div>
        )    
    }
}
ModalBase.propTypes = {
    id: PropTypesEx.elementId,
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    footer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'auto']),
    visible: PropTypes.bool,
    animated: PropTypes.bool,
    allowClose: PropTypes.bool,
    scrollable: PropTypes.bool,
    autoFocus: PropTypes.bool,
    onShow: PropTypes.func,
    onHide: PropTypes.func,
    backdrop: PropTypes.oneOf([false, true, 'static', 'simple']).isRequired
}
ModalBase.defaultProps = {
    visible: false,
    animated: true,
    allowClose: true,
    scrollable: false,
    autoFocus: true,
    backdrop: 'static'
}
ModalBase.HideModal = (node) => {
    if (Boolean(node)) {
        $(ReactDOM.findDOMNode(node)).modal('hide');
    }
}

export const MessageBoxIconStyle = {
    fontSize: '2rem', 
    lineHeight: '1.25'
};

class MessageBoxComponent extends React.Component {
	constructor(props, ...others) {
        super(props, ...others);
        
        this.state={result: MessageBoxComponent.RESULT_Esc};

        this.modalRef = React.createRef();
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleModalShow = this.handleModalShow.bind(this);
        this.handleModalHide = this.handleModalHide.bind(this);
    }

    handleModalShow(e) {
        const self = this;
        //We need to display MessageBox over other modals
        if (self._isMounted && !Boolean(self.isZIndexChanged)) {
            const $modal = $(e.target);
            const modalZIndex = parseInt($modal.css('z-index'));

            if (!isNaN(modalZIndex)) {
                const $backdrop = $($modal.data('bs.modal')._backdrop);

                if ($backdrop.length == 1) {
                    $modal.css('z-index', modalZIndex + 20);
                    $backdrop.css('z-index', modalZIndex + 10);
                    self.isZIndexChanged = true;
                }
            }
        }
    }

    handleModalHide(e) {
        const self = this;
        if (self._isMounted) {
            // self.handleButtonClick(MessageBoxComponent.RESULT_Esc);
            self.props.callback(self.state.result, self.props.callbackData);
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleButtonClick(e) {
        const self = this;
        const code = parseInt(e.target.getAttribute('data-code'));

        if (!isNaN(code)) {
            PreventDOMLock(() => {
                self.setState(
                    {result: code},
                    () => ModalBase.HideModal(self.modalRef.current));
            })
        }
        //self.props.callback(code, self.props.callbackData);
    }

    renderIcon() {
        const {icon} = this.props;

        let iconClass = 'mr-3 glyphicons';

        switch (icon) {
            case MessageBoxComponent.ICON_Error: 
                iconClass += ' glyphicons-circle_remove text-error';
                break;
            case MessageBoxComponent.ICON_Question: 
                iconClass += ' glyphicons-circle_question_mark text-primary';
                break;
            case MessageBoxComponent.ICON_Warning: 
                iconClass += ' glyphicons-warning_sign text-warning';
                break;
            case MessageBoxComponent.ICON_Info: 
                iconClass += ' glyphicons-circle_info text-primary';
                break;
        }

        return Boolean(iconClass) && <i className={iconClass} style={MessageBoxIconStyle} />;
    }

    renderButtons() {
        const self = this;
        const {buttons, buttonTitles, buttonClasses, id} = self.props;
        
        let defTitles = {yes: 'Yes', no: 'No', ok: 'Ok', cancel: 'Cancel'};
        let defClasses = {yes: 'btn-outline-primary', no: 'btn-outline-secondary', ok: 'btn-outline-primary', cancel: 'btn-outline-secondary'};
        let titles = {...defTitles, ...buttonTitles};
        let classes = {...defClasses, ...buttonClasses};

        const btns = [];
        if ((buttons == MessageBoxComponent.BUTTONS_YesNoCancel) || (buttons == MessageBoxComponent.BUTTONS_YesNo)) {
            btns.push({code: MessageBoxComponent.RESULT_Yes, id: 'btnYes', className: 'btn ' + (classes.yes || defClasses.yes), content: titles.yes || defTitles.yes});
            btns.push({code: MessageBoxComponent.RESULT_No, id: 'btnNo', className: 'btn ' + (classes.no || defClasses.no), content: titles.no || defTitles.no});
        }
        if ((buttons == MessageBoxComponent.BUTTONS_Ok) || (buttons == MessageBoxComponent.BUTTONS_Cancel)) {
            btns.push({code: MessageBoxComponent.RESULT_Ok, id: 'btnOk', className: 'btn ' + (classes.ok || defClasses.ok), content: titles.ok || defTitles.ok});
        }
        if ((buttons == MessageBoxComponent.BUTTONS_Cancel) || (buttons == MessageBoxComponent.BUTTONS_YesNoCancel)) {
            btns.push({code: MessageBoxComponent.RESULT_Cancel, id: 'btnCancel', className: 'btn ' + (classes.cancel || defClasses.cancel), content: titles.cancel || defTitles.cancel});
        }
        if (btns.length == 0) {
            btns.push({code: MessageBoxComponent.RESULT_Ok, id: 'btnOk', className: 'btn ' + (classes.ok || defClasses.ok), content: titles.ok || defTitles.ok});
        }

        return (
            <div className="form-buttons">
                {btns.map(item => {
                    return (
                        <button 
                            id={Boolean(id) ? id + '.' + item.id : null}
                            type="button" 
                            key={item.id} 
                            className={NormalizeClassNameString(item.className)}
                            data-code={item.code}
                            onClick={self.handleButtonClick}
                        >
                            {item.content}
                        </button>
                    )
                })}
            </div>
        )
    }

    render() {
        const self = this;
        const {title, message, buttons, className, id} = self.props;
        const allowClose = 
            (buttons == MessageBoxComponent.BUTTONS_Ok) || 
            (buttons == MessageBoxComponent.BUTTONS_Cancel) || 
            (buttons == MessageBoxComponent.BUTTONS_YesNoCancel);

        return (
            <ModalBase
                id={id}
                ref={self.modalRef}
                visible
                animated
                autoFocus
                className={className}
                allowClose={allowClose}
                backdrop="simple"
                title={title}
                body={
                    <div className="d-flex">
                        {self.renderIcon()}
                        <div className="text-pre-line">
                            {message}
                        </div>
                    </div>
                }
                footer={
                    <div>
                        {self.renderButtons()}
                    </div>
                }
                onHide={self.handleModalHide}
                onShow={self.handleModalShow}
            />
        )    
    }
}
MessageBoxComponent.propTypes = {
    id: PropTypesEx.elementId,
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    buttons: PropTypes.oneOf([0,1,3,4]), //0 - Ok, 1 - Cancel, 3 - YesNoCancel, 4 - YesNo
    //buttonTitles: PropTypes.object,
    buttonTitles: PropTypes.shape({
        yes: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), 
        no: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), 
        ok: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), 
        cancel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
    //buttonClasses: PropTypes.object,
    buttonClasses: PropTypes.shape({
        yes: PropTypes.string, 
        no: PropTypes.string, 
        ok: PropTypes.string, 
        cancel: PropTypes.string,
    }),
    icon: PropTypes.oneOf([0,16,32,48,64]), //0 - none, 16 - error, 32 - question, 48 - warning, 64 - info
    callback: PropTypes.func.isRequired, //(code, callbackData) - code = 1 - ok, 2 - cancel, 6 - yes, 7 - no
    callbackData: PropTypes.any,
}
MessageBoxComponent.defaultProps = {
    buttons: 0,
    icon: 0,
}

MessageBoxComponent.BUTTONS_Ok = 0;
MessageBoxComponent.BUTTONS_Cancel = 1;
MessageBoxComponent.BUTTONS_YesNoCancel = 3;
MessageBoxComponent.BUTTONS_YesNo = 4;

MessageBoxComponent.ICON_None = 0;
MessageBoxComponent.ICON_Error = 16;
MessageBoxComponent.ICON_Question = 32;
MessageBoxComponent.ICON_Warning = 48;
MessageBoxComponent.ICON_Info = 64;

MessageBoxComponent.RESULT_Esc = 0;
MessageBoxComponent.RESULT_Ok = 1;
MessageBoxComponent.RESULT_Cancel = 2;
MessageBoxComponent.RESULT_Yes = 6;
MessageBoxComponent.RESULT_No = 7;


export {ModalBase, MessageBoxComponent};